import Vue from "vue";
import Vuex from "vuex";
import firebase from "firebase/app";
import router from "../router";
import { db, storage } from "../main";

//crear jwt
const jwt = require("jsonwebtoken");
// para decodificar el jwt
import decode from "jwt-decode";

//Llamada mail.php alojado en comercialav.com
import axios from "axios";
import { exit } from "process";
import {
  siguienteCodigoAbono,
  etiquetaFacturaEmail,
} from "../utils/codigoAbono";
const querystring = require("querystring");

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    usuario: "",
    error: "",
    abonos: [],
    roles: [],
    isAdmin: false,
    abono: [],
    showDetalles: false,
    carga: false,
    search: "",
    snackBar: false,
    snackMensaje: "",
    snackColor: "",
    cargarRoles: false,
    guardarRevision: false,
  },
  getters: {
    existeUsuario: (state) => {
      if (
        state.usuario === null ||
        state.usuario === "" ||
        state.usuario === undefined ||
        state.usuario.email === undefined
      ) {
        return false;
      } else {
        return true;
      }
    },
    getUsuarioActual: (state) => {
      return state.usuario;
    },
    arrayFiltrado(state) {
      let arregloFiltrado = [];
      const q = state.search || "";
      for (let abono of state.abonos) {
        let factura = (abono.factura || "").toLowerCase();
        let cliente = (abono.cliente || "").toLowerCase();
        let estado = (abono.autorizado || "").toLowerCase();
        let codigo = (abono.codigoAbono || "").toLowerCase();
        if (
          factura.indexOf(q) >= 0 ||
          cliente.indexOf(q) >= 0 ||
          estado.indexOf(q) >= 0 ||
          codigo.indexOf(q) >= 0
        ) {
          arregloFiltrado.push(abono);
        }
      }
      return arregloFiltrado;
    },
  },
  mutations: {
    setUsuario(state, payload) {
      state.usuario = payload;
    },
    setError(state, payload) {
      state.error = payload;
    },
    setAbonos(state, abonos) {
      state.abonos = abonos;
    },
    setEliminarAbono(state, id) {
      state.abonos = state.abonos.filter((item) => item.id !== id);
    },
    setUserRoles(state, usuarios) {
      state.roles = usuarios;
    },
    updateUserRol(state, usuario) {
      state.roles
        .filter((item) => item.id == usuario.id)
        .forEach((item) => (item.rol = usuario.rol));
    },
    mostrarDetalles(state) {
      state.showDetalles = true;
    },
    ocultarDetalles(state) {
      state.showDetalles = false;
    },
    updateStatusAutorizado(state, [abono, condiciones, autorizar]) {
      state.abonos
        .filter((item) => item.id == abono)
        .forEach((item) => (item.color = autorizar.color));
      state.abonos
        .filter((item) => item.id == abono)
        .forEach((item) => (item.autorizado = autorizar.text));
      state.abonos
        .filter((item) => item.id == abono)
        .forEach((item) => (item.condiciones = condiciones));
    },
    updateStatusRevision(state, [id, revision]) {
      state.abonos
        .filter((item) => item.id == id)
        .forEach((item) => (item.abierto = revision.abierto));
      state.abonos
        .filter((item) => item.id == id)
        .forEach((item) => (item.estado = revision.estado));
      state.abonos
        .filter((item) => item.id == id)
        .forEach((item) => (item.observRevision = revision.observaciones));
      state.abonos
        .filter((item) => item.id == id)
        .forEach((item) => (item.tramitar = revision.tramitar));
    },
    updateStatusAbonado(state, { id, numeroAbonoPyme }) {
      state.abonos
        .filter((item) => item.id == id)
        .forEach((item) => {
          item.abonado = true
          item.numeroAbonoPyme = numeroAbonoPyme
          item.tramitar = 'Almacén' // si quieres reflejar el paso inmediato a almacén
        })
    },
    updateStatusRecogido(state, { id, recogido, rechazoAlmacen, observAlmacen }) {
      state.abonos
        .filter((item) => item.id == id)
        .forEach((item) => {
          item.recogido = recogido;
          item.rechazoAlmacen = rechazoAlmacen;
          item.observAlmacen = observAlmacen;
        });
    },
    cargarFirebase(state, payload) {
      state.carga = payload;
    },
    SetSnackBarAlert(state, payload) {
      state.snackBar = true;
      state.snackMensaje = payload.mensaje;
      state.snackColor = payload.color;
    },
    setCargarRoles(state, payload) {
      state.cargarRoles = payload;
    },
    updateImagesAbonos(state, images) {
      state.abonos.images = images;
    },
  },
  actions: {
    crearUsuario({ commit }, payload) {
      firebase
        .auth()
        .createUserWithEmailAndPassword(payload.email, payload.pass)
        .then((res) => {
          //commit('setUsuario', {email:res.user.email, uid: res.user.uid})

          //Añadir usuario un rol en bd
          db.collection("roles").add({
            usuario: res.user.email,
            isla: payload.isla,
            rol: "SOLICITAR",
          });

          //reenviamos al Inicio
          router.push({
            name: "Home",
          });
        })
        .catch((err) => {
          console.log(err);
          commit("setError", err.message);
        });
    },
    ingresoUsuario({ commit, dispatch }, payload) {
      commit("setCargarRoles", true);
      firebase
        .auth()
        .signInWithEmailAndPassword(payload.email, payload.pass)
        .then((res) => {
          dispatch("obtenerRolUsuario", {
            email: payload.email,
            uid: payload.uid,
          });
        })
        .catch((err) => {
          console.log(err);
          commit("setCargarRoles", false);
          commit("setError", err.message);
        });
    },
    //Esta funcion se llama en el ingreso de usuario
    obtenerRolUsuario({ commit }, payload) {
      const roles = [];
      db.collection("roles")
        .where("usuario", "==", payload.email)
        .get()
        .then((res) => {
          if (res.empty) {
            console.log("No matching documents.");
          } else {
            res.forEach((doc) => {
              let rol = doc.data();
              roles.push(rol);
            });
          }
          let usuario = {
            email: payload.email,
            uid: payload.uid,
            rol: roles[0].rol,
            isla: roles[0].isla,
          };
          commit("setUsuario", usuario);

          //Creo un jwt en local
          const token = jwt.sign(
            {
              data: usuario,
            },
            "secret",
            {
              expiresIn: 60 * 60 * 24 * 30,
            }
          ); //Expira en 30 dias
          localStorage.setItem("access_token", token);
          commit("setCargarRoles", false);
          router.push({
            name: "Home",
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //Esta funcion se llama para saber si el usuario esta autenticado en caso de recarga
    detectarUsuario({ commit }, payload) {
      if (payload != null) {
        const roles = [];
        db.collection("roles")
          .where("usuario", "==", payload.email)
          .get()
          .then((res) => {
            if (res.empty) {
              console.log("No matching documents.");
            } else {
              res.forEach((doc) => {
                let rol = doc.data();
                roles.push(rol);
              });
            }
            commit("setUsuario", {
              email: payload.email,
              uid: payload.uid,
              rol: roles[0].rol,
              isla: roles[0].isla,
            });
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        commit("setUsuario", null);
      }
    },
    cerrarSesion({ commit }) {
      firebase.auth().signOut();
      commit("setUsuario", null),
        router.push({
          name: "Login",
        });
    },
    async crearAbono({ commit, dispatch }, [abono, fecha, usuario]) {
      // Los productos ya vienen formateados con <br/> desde el componente
      let codigoAbono;
      try {
        codigoAbono = await siguienteCodigoAbono(db);
      } catch (err) {
        console.log(err);
        commit("SetSnackBarAlert", {
          mensaje: "Error al generar el identificador del abono",
          color: "error",
        });
        return;
      }

      db.collection("abonos")
        .add({
          factura: abono.factura,
          codigoAbono,
          comercial: usuario.email,
          isla: usuario.isla,
          cliente: abono.cliente,
          fecha: fecha,
          productos: abono.productos,
          motivo: abono.motivo,
          bajoPedido: abono.bajoPedido,
          cambioPrecio: abono.cambioPrecio,
          activoWeb: abono.activoWeb,
          precintado: abono.precintado,
          observComercial: abono.observaciones,
          autorizado: "En Espera",
          condiciones: "",
          abierto: false,
          estado: false,
          noEntregadoCliente: abono.noEntregadoCliente,
          tramitar: "En Espera",
          observRevision: "",
          color: "primary",
          fechaCreate: Date.now(),
          ultimaMod: Date.now(),
        })
        .then((doc) => {
          console.log(doc);
          let copiaCorreo = "";
          if (usuario.isla == "TF") {
            copiaCorreo = ";david.leon@av-online.es";
          } else {
            copiaCorreo = "";
          }
          const templateParams = {
            factura: `${codigoAbono} · ${abono.factura}`,
            codigoAbono,
            cliente: abono.cliente,
            productos: abono.productos,
            fecha: fecha,
            motivo: abono.motivo,
            isla: usuario.isla,
            comercial: usuario.email,
            bajoPedido: abono.bajoPedido,
            cambioPrecio: abono.cambioPrecio,
            activoWeb: abono.activoWeb,
            precintado: abono.precintado,
            noEntregadoCliente: abono.noEntregadoCliente,
            observaciones: abono.observaciones,
            copia: usuario.email + copiaCorreo,
          };
          axios
            .post(
              "https://www.avpos.es/abonos/mail-create.php",
              querystring.stringify(templateParams)
            )
            .then((res) => {
              commit("SetSnackBarAlert", {
                mensaje: "Abono creado: " + codigoAbono,
                color: "success",
              });
            })
            .catch((err) => {
              commit("SetSnackBarAlert", {
                mensaje: "Error al Enviar el Email",
                color: "error",
              });
            });

          dispatch("getAbonos", localStorage.getItem("access_token"));
        })
        .catch((err) => {
          console.log(err);
          commit("SetSnackBarAlert", {
            mensaje: "Error al Guardar el Abono",
            color: "error",
          });
        });
    },
    getAbonos({ commit }, token) {
      //loader
      commit("cargarFirebase", true);

      const abonos = [];
      const usuario = decode(token);
      console.log(usuario.data.rol)
      if (usuario.data.rol == "ADMIN") {
        db.collection("abonos")
          .get()
          .then((snapshot) => {
            snapshot.forEach((doc) => {
              let abono = doc.data();
              abono.id = doc.id;
              abonos.push(abono);
            });
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (
        usuario.data.rol == "SOLICITAR" ||
        usuario.data.rol == "ABONAR" ||
        usuario.data.rol == "RECOGER"
      ) {
        db.collection("abonos")
          .where("isla", "==", usuario.data.isla)
          .get()
          .then((snapshot) => {
            snapshot.forEach((doc) => {
              let abono = doc.data();
              abono.id = doc.id;
              abonos.push(abono);
            });
            console.log(abonos)
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (usuario.data.rol == "REVISAR") {
        db.collection("abonos")
          .where("isla", "==", usuario.data.isla)
          .where("autorizado", "==", "Aceptado")
          .get()
          .then((snapshot) => {
            snapshot.forEach((doc) => {
              let abono = doc.data();
              abono.id = doc.id;
              abonos.push(abono);
            });
          })
          .catch((err) => {
            console.log(err);
          });
      }

      //close Loader
      setTimeout(() => {
        commit("cargarFirebase", false);
        commit("setAbonos", abonos);
      }, 3000);
    },
    eliminarAbono({ commit, dispatch }, id) {
      db.collection("abonos")
        .doc(id)
        .delete()
        .then(() => {
          console.log("abono eliminado");
          /* dispatch('getAbonos') */
          commit("setEliminarAbono", id);
        });
    },
    getUserRoles({ commit }) {
      const usuarios = [];
      db.collection("roles")
        .get()
        .then((res) => {
          res.forEach((doc) => {
            let usuario = doc.data();
            usuario.id = doc.id;
            usuarios.push(usuario);
          });
        })
        .catch((err) => {
          console.log(err);
        });

      commit("setUserRoles", usuarios);
    },
    editarUserRoles({ commit }, rol) {
      db.collection("roles")
        .doc(rol.id)
        .update({
          rol: rol.rol,
        })
        .then((res) => {
          commit("updateUserRol", rol);
        })
        .catch((err) => { });
    },
    autorizarAbono({ commit, dispatch }, [abono, autorizar]) {
      db.collection("abonos")
        .doc(abono.id)
        .update({
          condiciones: abono.condiciones,
          autorizado: autorizar.text,
          color: autorizar.color,
          ultimaMod: Date.now(),
        })
        .then((res) => {
          commit("updateStatusAutorizado", [
            abono.id,
            abono.condiciones,
            autorizar,
          ]);
          if (abono.noEntregadoCliente == "Si") {
            //Envio de correo emailjs
            let color = autorizar.color;
            let correoRevision = "";
            if (autorizar.text == "Aceptado") {
              if (abono.isla == "GC") {
                correoRevision = "salvador.santana@av-online.es";
              } else {
                correoRevision = "francisco.delgado@av-online.es";
              }
            }
            let html =
              (abono.codigoAbono
                ? "Identificador: <strong>" + abono.codigoAbono + "</strong><br>"
                : "") +
              'Se ha actualizado el Abono a <span style="color: #fff; padding: 5px 10px; background-color: ' +
              color +
              '">' +
              autorizar.text +
              "</span> con las siguientes condiciones: " +
              abono.condiciones;
            const templateParams = {
              copia: correoRevision,
              factura: etiquetaFacturaEmail(abono),
              codigoAbono: abono.codigoAbono || "",
              text: html,
              destino: abono.comercial,
            };

            axios
              .post(
                "https://www.avpos.es/abonos/mail.php",
                querystring.stringify(templateParams)
              )
              .then((res) => {
                console.log(res);
                //Añadimos mensaje de enviado en panel
                if (autorizar.text == "Aceptado") {
                  commit("SetSnackBarAlert", {
                    mensaje: "Abono Autorizado con Exito",
                    color: "success",
                  });
                } else {
                  commit("SetSnackBarAlert", {
                    mensaje: "Abono Denegado con Exito",
                    color: "error",
                  });
                }
              })
              .catch((err) => {
                commit("SetSnackBarAlert", {
                  mensaje: "Error al Enviar el Email",
                  color: "error",
                });
              });

          } else if (abono.noEntregadoCliente == "No") {
            let revisionCl = {
              abierto: 'No',
              estado: "true",
              observaciones: '',
              tramitar: "Tramitado",
            }
            /* Enviamos multiples parametros a una accion */
            dispatch("tramitarAbono", [abono, revisionCl]);
          } else {
            commit("SetSnackBarAlert", {
              mensaje: "Error al Guardar la Autorización",
              color: "error",
            });
          }
        })
        .catch((err) => {
          console.log(err)
          commit("SetSnackBarAlert", {
            mensaje: "Error al Guardar la Autorización",
            color: "error",
          });
        });
    },
    tramitarAbono({ commit, dispatch }, [abono, revision]) {
      db.collection("abonos")
        .doc(abono.id)
        .update({
          abierto: revision.abierto,
          estado: revision.estado,
          observRevision: revision.observaciones,
          tramitar: revision.tramitar,
          ultimaMod: Date.now(),
        })
        .then((res) => {
          commit("updateStatusRevision", [abono.id, revision]);
          //Envio de correo email
          let color = revision.tramitar == "Tramitado" ? "green" : "red";
          let emailcopia =
            abono.isla == "GC"
              ? "almacen.gc@av-online.es"
              : "francisco.delgado@av-online.es;almacen.tf@av-online.es";
          var templateParams = {
            factura: etiquetaFacturaEmail(abono),
            codigoAbono: abono.codigoAbono || "",
            text:
              (abono.codigoAbono
                ? "Identificador: <strong>" + abono.codigoAbono + "</strong><br>"
                : "") +
              'Se ha actualizado el Abono a <span style="color: #fff; padding: 5px 10px; background-color: ' +
              color +
              '">' +
              abono.tramitar +
              "</span> con las siguientes observaciones: <br>" +
              revision.observaciones +
              "<br> Productos a Abonar: " +
              abono.productos,
            copia: emailcopia,
            destino: abono.comercial,
          };
          axios
            .post(
              "https://www.avpos.es/abonos/mail.php",
              querystring.stringify(templateParams)
            )
            .then((res) => {
              if (revision.tramitar == "Tramitado") {
                commit("SetSnackBarAlert", {
                  mensaje: "Abono Tramitado con Exito",
                  color: "success",
                });
              } else {
                commit("SetSnackBarAlert", {
                  mensaje: "Abono Rechazado con Exito",
                  color: "error",
                });
              }
            })
            .catch((err) => {
              commit("SetSnackBarAlert", {
                mensaje: "Error al Enviar el Email",
                color: "error",
              });
            });
        })
        .catch((err) => {
          commit("SetSnackBarAlert", {
            mensaje: "Error al Guardar la Revisión",
            color: "error",
          });
        });
    },
    buscador({ commit, state }, payload) {
      state.search = payload.toLowerCase();
    },
    subirImagenes({ commit, state }, [files, factura, id]) {
      if (Array.isArray(files) && files.length) {
        //añadimos la carga de los datos
        state.guardarRevision = true;
        let images = [];
        files.forEach((file) => {
          const uploadImage = storage
            .ref()
            .child(factura)
            .child(file.name)
            .put(file);
          uploadImage.on(
            "state_changed",
            (snapshot) => { },
            (error) => { },
            () => {
              storage
                .ref()
                .child(factura)
                .child(file.name)
                .getDownloadURL()
                .then((url) => {
                  images.push(url);
                  db.collection("abonos")
                    .doc(id)
                    .update({
                      images: firebase.firestore.FieldValue.arrayUnion(url),
                    });
                });
            }
          );
        });
        commit("updateImagesAbonos", images);
        state.guardarRevision = false;
      }
    },
    RecogerAbono({ commit, dispatch }, { abono, decision, observacion }) {
      const rechazado = decision === "rechazado";
      const observAlmacen = String(observacion || "").trim();
      if (rechazado && observAlmacen.length < 3) {
        commit("SetSnackBarAlert", {
          mensaje: "Indica el motivo del rechazo",
          color: "error",
        });
        return;
      }

      db.collection("abonos")
        .doc(abono.id)
        .update({
          recogido: !rechazado,
          rechazoAlmacen: rechazado,
          observAlmacen: observAlmacen,
          ultimaMod: Date.now(),
        })
        .then((res) => {
          commit("updateStatusRecogido", {
            id: abono.id,
            recogido: !rechazado,
            rechazoAlmacen: rechazado,
            observAlmacen,
          });
          //Envio de correo email
          let color = rechazado ? "red" : "green";
          let estado = rechazado ? "Rechazado por almacén" : "Recogido";
          let detalle = observAlmacen
            ? "<br>Observaciones almacén: " + observAlmacen
            : "";
          let emailcopia =
            abono.isla == "GC"
              ? "almacen.gc@av-online.es;maribel.hinarejos@av-online.es;dunia.acosta@av-online.es;marisol.delrosario@av-online.es"
              : "francisco.delgado@av-online.es;almacen.tf@av-online.es;guacimara.lopez@av-online.es";
          var templateParams = {
            factura: etiquetaFacturaEmail(abono),
            codigoAbono: abono.codigoAbono || "",
            text:
              (abono.codigoAbono
                ? "Identificador: <strong>" + abono.codigoAbono + "</strong><br>"
                : "") +
              'Se ha actualizado el Abono a <span style="color: #fff; padding: 5px 10px; background-color: ' +
              color +
              '">' +
              estado +
              "</span>" +
              detalle,
            copia: emailcopia,
            destino: abono.comercial,
          };
          axios
            .post(
              "https://www.avpos.es/abonos/mail.php",
              querystring.stringify(templateParams)
            )
            .then((res) => {
              console.log(res);
              commit("SetSnackBarAlert", {
                mensaje: rechazado
                  ? "Rechazado por almacén."
                  : "Recogido con exito.",
                color: rechazado ? "error" : "success",
              });
            })
            .catch((err) => {
              console.log(err);
              commit("SetSnackBarAlert", {
                mensaje: "Error al Enviar el Email",
                color: "error",
              });
            });
          dispatch("getAbonos", localStorage.getItem("access_token"));
        })
        .catch((err) => {
          console.log(err);
          commit("SetSnackBarAlert", {
            mensaje: "Error al guardar la confirmación de abono",
            color: "error",
          });
        });
    },
    Abonar({ commit, dispatch }, { id, numeroAbonoPyme }) {
      if (!numeroAbonoPyme || String(numeroAbonoPyme).trim().length < 4) {
        commit("SetSnackBarAlert", {
          mensaje: "Nº de abono Pyme obligatorio",
          color: "error",
        })
        return
      }

      db.collection("abonos")
        .doc(id)
        .update({
          abonado: true,
          numeroAbonoPyme: String(numeroAbonoPyme).trim(),
          tramitar: "Almacén",          // pasa al siguiente punto
          ultimaMod: Date.now(),
        })
        .then(() => {
          commit("updateStatusAbonado", { id, numeroAbonoPyme })
          // Email
          const color = "green"
          // recupera el abono actual del estado para obtener isla/factura/comercial
          const abono = (this.state.abonos || []).find(x => x.id === id) || {}
          const emailcopia =
            abono.isla == "GC"
              ? "almacen.gc@av-online.es;maribel.hinarejos@av-online.es;marisol.delrosario@av-online.es;dunia.acosta@av-online.es;melania.arencibia@av-online.es"
              : "almacen.tf@av-online.es;guacimara.lopez@av-online.es;melania.arencibia@av-online.es"

          const templateParams = {
            factura: etiquetaFacturaEmail(abono),
            codigoAbono: abono.codigoAbono || "",
            text:
              (abono.codigoAbono
                ? "Identificador: <strong>" + abono.codigoAbono + "</strong><br>"
                : "") +
              'Se ha actualizado el Abono a <span style="color:#fff;padding:5px 10px;background-color:' +
              color +
              '">Abonado</span><br>Nº abono Pyme: ' + String(numeroAbonoPyme).trim(),
            copia: emailcopia,
            destino: abono.comercial,
          }

          axios.post(
            "https://www.avpos.es/abonos/mail.php",
            querystring.stringify(templateParams)
          ).then(() => {
            commit("SetSnackBarAlert", { mensaje: "Abonado con éxito.", color: "success" })
          }).catch(() => {
            commit("SetSnackBarAlert", { mensaje: "Error al enviar el email", color: "error" })
          })

          dispatch("getAbonos", localStorage.getItem("access_token"))
        })
        .catch(() => {
          commit("SetSnackBarAlert", {
            mensaje: "Error al guardar la confirmación de abono",
            color: "error",
          })
        })
    }
  },
  modules: {},
});
